
import {computed, ComputedRef, defineComponent, onMounted, Ref, ref, watch, reactive} from 'vue'
import {useStore} from 'vuex'
import {useI18n} from 'vue-i18n'

import {StateType as HomeStateType} from '../../store'
import {PaginationConfig} from '../../data'
import {message, Form} from 'ant-design-vue'
import downloadfile from '@/utils/download'
import {LoadingOutlined, UploadOutlined, DownloadOutlined} from '@ant-design/icons-vue'

import {selfOrPostSearchType} from '../../data'

interface selfdeliveryInfoData {
  columns: any
  list: any
  handleExport: (e: MouseEvent) => void
  changeTxt: (val: string, type: string) => string
}

interface paginationDir {
  pageNo: number
  pageSize: number
}

export default defineComponent({
  name: 'selfdeliveryInfo',
  components: {LoadingOutlined, UploadOutlined, DownloadOutlined},
  setup(): selfdeliveryInfoData {
    const store = useStore<{
      Home: HomeStateType
    }>()
    const pageNum = reactive<paginationDir>({pageNo: 1, pageSize: 10})
    const userMsg = JSON.parse(String(localStorage.getItem('userMsg'))) || {}
    const {userCode} = userMsg
    const columns = [
      {title: '站点名称', dataIndex: 'stationNameCn'},
      {title: '站点所在省份', dataIndex: 'stationProvince'},
      {title: '站点所在城市', dataIndex: 'stationCity'},
      {title: '服务方式', dataIndex: 'status'},
      {title: '自送窗口时间', dataIndex: 'businessCycle'},
      {title: '自送站点地址', dataIndex: 'stationAddress'},
      {title: '负责人', dataIndex: 'contactName'},
      {title: '联系方式', dataIndex: 'contactInfo'},
      {title: '备注', dataIndex: 'remark', width: 200},
    ]

    //获取地址
    const list = computed<any[]>(() => store.state.Home.selfDeliveryList)
    console.log('store.state.Home.selfDeliveryList', store.state.Home.selfDeliveryList)
    const getExplainTab = async (params: selfOrPostSearchType) => {
      try {
        const res: boolean = await store.dispatch('Home/selfDeliveryScopeFn',params)
      } catch (error) {
        message.warning('获取上门揽收范围失败！')
      }
    }

    //枚举转换
    const changeTxt = (val: string, type: string) => {
      const objway = {
        '1': '上门揽收',
        '2': '站点自送',
      }
      const clObj = {
        1: '周一',
        2: '周二',
        3: '周三',
        4: '周四',
        5: '周五',
        6: '周六',
        7: '周日',
      }
      const cityList = localStorage.getItem('areaList') && JSON.parse(String(localStorage.getItem('areaList')))
      switch (type) {
        case 'stationProvince':
          return cityList[val] || val
        case 'stationCity':
          return cityList[val] || val
        case 'status':
          return objway[val] || val
        case 'businessCycle':
          let txt: string = ''
          val.length > 0 &&
            val.split(',').forEach((i: any) => {
              txt += `${clObj[i]},`
            })
          txt = txt.substring(0, txt.length - 1)
          return txt || val
      }
    }

    //导出
    const handleExport = (e: MouseEvent) => {
      downloadfile({
        params: {userCode: userMsg?.userCode,supportSelf:0},
        url: '/seller/v1/homePage/selfDeliveryScopeExport',
        meth: 'post',
        filename: `自送范围${new Date().getTime()}.xlsx`,
        type: 'text/plain',
      })
    }

    onMounted(() => {
      getExplainTab({supportSelf:0})
    })

    return {
      columns,
      list,
      handleExport,
      changeTxt
    }
  },
})
